import React from 'react'
import { observer } from 'mobx-react-lite'
import Link from '@mui/material/Link'

export default observer(function GapUnderlineLink({ children, href, target, onClick }: { children: React.ReactNode, href: string, target?: string, onClick?: React.MouseEventHandler<HTMLAnchorElement> | undefined }) {
   return <Link
      variant="body2"
      {... { href, onClick }}
      target={target || '_blank'}
      sx={{
         textDecoration: 'underline',
         fontSize: '700',
         cursor: 'pointer',
         display: 'inline',
      }}
   >{children}</Link>
})